webpackJsonp([2],{

/***/ 13:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INSTANCE; });
/* unused harmony export BASE_URL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return download; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var BASE_URL = location && (location.hostname === 'we.nowyu.com' || location.hostname === 'me.nowyu.com') ? location.protocol + '//api.nowyu.com/v1' : 'http://localhost:8080/v1';

var INSTANCE = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({ baseURL: BASE_URL });

function download(path, fileName) {
    return INSTANCE.get(path).then(function (response) {
        var mime = response.headers['content-type'];
        var data = response.data;

        return new Blob([data], { type: mime });
    }).then(function (blob) {
        var anchor = document.createElement('a');
        var objectUrl = window.URL.createObjectURL(blob);

        anchor.href = objectUrl;
        anchor.download = fileName;
        anchor.click();

        window.URL.revokeObjectURL(objectUrl);
    });
}



/***/ }),

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  null,
  /* template */
  __webpack_require__(341),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(310)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(256),
  /* template */
  __webpack_require__(338),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4733b8fa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 195:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(257),
  /* template */
  __webpack_require__(339),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 198:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MainNavigation__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MainNavigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__MainNavigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainToolbar__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainToolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainToolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainBreadcrumb__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainBreadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainBreadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MainFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProfileProviderCard__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProfileProviderCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ProfileProviderCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FilteredConsentsList__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FilteredConsentsList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__FilteredConsentsList__);







/* harmony default export */ __webpack_exports__["a"] = ({
    MainNavigation: __WEBPACK_IMPORTED_MODULE_0__MainNavigation___default.a,
    MainToolbar: __WEBPACK_IMPORTED_MODULE_1__MainToolbar___default.a,
    MainBreadcrumb: __WEBPACK_IMPORTED_MODULE_2__MainBreadcrumb___default.a,
    MainFooter: __WEBPACK_IMPORTED_MODULE_3__MainFooter___default.a,
    ProfileProviderCard: __WEBPACK_IMPORTED_MODULE_4__ProfileProviderCard___default.a,
    FilteredConsentsList: __WEBPACK_IMPORTED_MODULE_5__FilteredConsentsList___default.a
});

/***/ }),

/***/ 199:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nav__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__errors__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__properties__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__profileProviders__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__intents__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__consents__ = __webpack_require__(247);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.debug = true;

var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */].Store({
    modules: {
        auth: __WEBPACK_IMPORTED_MODULE_2__auth__["b" /* default */],
        nav: __WEBPACK_IMPORTED_MODULE_3__nav__["a" /* default */],
        errors: __WEBPACK_IMPORTED_MODULE_4__errors__["a" /* default */],
        properties: __WEBPACK_IMPORTED_MODULE_5__properties__["a" /* default */],
        profileProviders: __WEBPACK_IMPORTED_MODULE_6__profileProviders__["a" /* default */],
        intents: __WEBPACK_IMPORTED_MODULE_7__intents__["a" /* default */],
        consents: __WEBPACK_IMPORTED_MODULE_8__consents__["a" /* default */]
    },
    strict: debug,
    plugins: []
}));

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(311)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(253),
  /* template */
  __webpack_require__(340),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(258),
  /* template */
  __webpack_require__(336),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 21:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isAuthenticated; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AUTH; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_auth0_js__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_auth0_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_auth0_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jwt_decode__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_api__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__auth0_json__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__auth0_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__auth0_json__);








var callbackUrl = __WEBPACK_IMPORTED_MODULE_6__auth0_json___default.a.callbackUrl;
if (location) {
    callbackUrl = location.origin + '/login/callback';
}

/* eslint-disable no-underscore-dangle */
__WEBPACK_IMPORTED_MODULE_4__utils_api__["a" /* default */].interceptors.response.use(function (response) {
    return response;
}, function (error) {
    var originalRequest = error.config;

    // if the error is 401 and hasn't already been retried
    if (error.response.status === 401 && !originalRequest._retry) {
        // mark our retry
        originalRequest._retry = true;

        // reauthenticate
        return __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].push({ path: '/login' });
    }

    // Do something with response error
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
});

function getItem(key) {
    var item = localStorage.getItem(key);

    if (item === 'undefined') {
        return undefined;
    }

    return item;
}

function setItem(key, value) {
    if (value) {
        localStorage.setItem(key, value);
    } else {
        localStorage.removeItem(key);
    }
}

function removeItem(key) {
    localStorage.removeItem(key);
}

/* eslint-disable no-param-reassign */
var utils = {
    saveLoginInfo: function saveLoginInfo(state, data) {
        state.auth = data;

        if (data && data.idToken) {
            state.profile = __WEBPACK_IMPORTED_MODULE_3_jwt_decode___default()(data.idToken);
        } else {
            state.profile = undefined;
        }

        __WEBPACK_IMPORTED_MODULE_4__utils_api__["a" /* default */].defaults.headers.common.Authorization = 'Bearer ' + data.accessToken;

        setItem('accessToken', data.accessToken);
        setItem('idToken', data.idToken);
        setItem('expiresAt', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data.expiresAt));
    },
    clearLoginInfo: function clearLoginInfo(state) {
        removeItem('accessToken');
        removeItem('idToken');
        removeItem('expiresAt');

        // clear auth info from state
        state.auth = undefined;
        state.profile = undefined;

        __WEBPACK_IMPORTED_MODULE_4__utils_api__["a" /* default */].defaults.headers.common.Authorization = undefined;
    },
    restoreLoginInfo: function restoreLoginInfo() {
        if (getItem('accessToken')) {
            // get security info from localstorage
            var accessToken = getItem('accessToken');
            var idToken = getItem('idToken');
            var expiresAt = JSON.parse(getItem('expiresAt'));

            return {
                accessToken: accessToken,
                idToken: idToken,
                expiresAt: expiresAt
            };
        }

        return undefined;
    }
};

function isAuthenticated() {
    return getItem('accessToken') && new Date().getTime() < getItem('expiresAt');
}

var AUTH = {
    namespaced: true,
    state: {
        auth: undefined,
        auth0: new __WEBPACK_IMPORTED_MODULE_2_auth0_js___default.a.WebAuth({
            domain: __WEBPACK_IMPORTED_MODULE_6__auth0_json___default.a.domain,
            clientID: __WEBPACK_IMPORTED_MODULE_6__auth0_json___default.a.clientId,
            redirectUri: callbackUrl,
            audience: __WEBPACK_IMPORTED_MODULE_6__auth0_json___default.a.audience,
            responseType: __WEBPACK_IMPORTED_MODULE_6__auth0_json___default.a.responseType,
            scope: __WEBPACK_IMPORTED_MODULE_6__auth0_json___default.a.scope
        }),
        profile: undefined
    },
    getters: {
        authService: function authService(state) {
            return state.authService;
        },
        profile: function profile(state) {
            return state.profile;
        },
        authHeader: function authHeader(state) {
            if (state.auth) {
                return {
                    Authorization: 'Bearer ' + state.auth.accessToken
                };
            }

            return undefined;
        },
        organisationId: function organisationId(state) {
            return state.profile ? state.profile.sub : undefined;
        }
    },
    /* eslint-disable no-param-reassign */
    mutations: {
        SAVE_AUTH: function SAVE_AUTH(state, data) {
            utils.saveLoginInfo(state, data);
        },
        LOGOUT: function LOGOUT(state) {
            utils.clearLoginInfo(state);
        },
        AUTHORIZE: function AUTHORIZE(state, redirect) {
            if (!isAuthenticated()) {
                // save redirect in local storage to revive after return from Auth0
                setItem('redirect', redirect || '/');

                utils.clearLoginInfo(state);
                state.auth0.authorize();
            }
        }
    },
    actions: {
        LOGIN: function LOGIN(context) {
            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                context.state.auth0.parseHash(function (err, authResult) {
                    if (authResult && authResult.accessToken && authResult.idToken) {
                        context.commit('SAVE_AUTH', {
                            accessToken: authResult.accessToken,
                            idToken: authResult.idToken,
                            expiresAt: authResult.expiresIn * 1000 + new Date().getTime()
                        });

                        // revive redirect url from local storage
                        var redirect = getItem('redirect');
                        removeItem('redirect');

                        resolve(redirect);
                    } else if (err) {
                        reject(err);
                    }
                });
            });
        },
        INIT: function INIT(context) {
            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
                var loginInfo = utils.restoreLoginInfo();
                if (loginInfo) {
                    context.commit('SAVE_AUTH', loginInfo);
                }
                resolve(true);
            });
        }
    }
};



/***/ }),

/***/ 246:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_logger__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuejs_logger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router__ = __webpack_require__(31);











__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuejs_logger___default.a, {
    logLevel:  false ? 'debug' : 'info',
    // optional : defaults to false if not specified
    stringifyArguments: false,
    // optional : defaults to false if not specified
    showLogLevel: true
});
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_6__components__["a" /* default */]).forEach(function (key) {
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component(key, __WEBPACK_IMPORTED_MODULE_6__components__["a" /* default */][key]);
});

// sync the router with the vuex store.
// this registers `store.state.route`
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */]);

// interesting ref on how to init security creds on app reload
// https://stackoverflow.com/questions/42579601/how-to-access-async-store-data-in-vue-router-for-usage-in-beforeenter-hook
__WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].dispatch('auth/INIT').then(function () {
    // create the app instance.
    // here we inject the router and store to all child components,
    // making them available everywhere as `this.$router` and `this.$store`.
    /* eslint-disable no-new */
    new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
        el: '#app',
        router: __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */],
        store: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */],
        render: function render(h) {
            return h(__WEBPACK_IMPORTED_MODULE_5__App___default.a);
        }
    });
});

/***/ }),

/***/ 247:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_api__ = __webpack_require__(13);


/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: {
        filter: 'all',
        consents: [],
        consent: undefined
    },
    getters: {},
    /* eslint-disable no-param-reassign */
    mutations: {
        LIST: function LIST(state, data) {
            state.consents = data;
        },
        CONSENT: function CONSENT(state, data) {
            state.consent = data;
        },
        FILTER: function FILTER(state, value) {
            state.filter = value;
        }
    },
    actions: {
        LIST_ALL: function LIST_ALL(context) {
            var filter = context.state.filter;
            var issuer = this.getters['auth/organisationId'];
            return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].get('/' + issuer + '/consents?filter=' + filter).then(function (response) {
                return context.commit('LIST', response.data);
            }).catch(function (error) {
                return context.commit('errors/ADD', error, { root: true });
            });
        },
        LOAD_CONSENT: function LOAD_CONSENT(context, _ref) {
            var issuer = _ref.issuer,
                intent = _ref.intent,
                user = _ref.user;

            return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].get('/' + issuer + '/intents/' + intent + '/users/' + user + '/consent').then(function (response) {
                return context.commit('CONSENT', response.data);
            }).catch(function (error) {
                return context.commit('errors/ADD', error, { root: true });
            });
        },
        LIST_FILTER: function LIST_FILTER(context, filter) {
            if (filter !== context.state.filter) {
                /* eslint-disable no-console */
                console.log('filter changed from ', context.state.filter, ' to ', filter);
                context.commit('FILTER', filter);
                var issuer = this.getters['auth/organisationId'];
                return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].get('/' + issuer + '/consents?filter=' + filter).then(function (response) {
                    return context.commit('LIST', response.data);
                }).catch(function (error) {
                    return context.commit('errors/ADD', error, { root: true });
                });
            }

            /* eslint-disable no-console */
            console.log('filter was not changed from ', filter);
            return null;
        }
    }
});

/***/ }),

/***/ 248:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: {
        errors: []
    },
    getters: {
        listErrors: function listErrors(state) {
            return state.errors;
        }
    },
    /* eslint-disable no-param-reassign */
    mutations: {
        CLEAR: function CLEAR(state) {
            state.errors = [];
        },
        ADD: function ADD(state, data) {
            state.errors.push(data);
        }
    },
    actions: {}
});

/***/ }),

/***/ 249:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_api__ = __webpack_require__(13);




var KNOWN_SCOPES = ['facebook:profile', 'facebook:email', 'facebook:registration-date', 'facebook:birth-day', 'facebook:gender', 'facebook:current-city', 'facebook:hometown', 'facebook:relationship-status', 'facebook:family', 'facebook:education', 'facebook:employers', 'facebook:interests', 'facebook:music', 'facebook:books', 'facebook:movies', 'facebook:other', 'facebook:games', 'facebook:networks', 'facebook:apps', 'facebook:pages-admin', 'facebook:address', 'facebook:emails', 'facebook:phones', 'facebook:screen-name', 'facebook:address-book', 'facebook:call-history', 'facebook:sms-history', 'facebook:mms-history', 'gplus:kind', 'gplus:occupation', 'gplus:birthday', 'gplus:gender', 'gplus:emails', 'gplus:urls', 'gplus:object-type', 'gplus:id', 'gplus:display-name', 'gplus:name', 'gplus:tagline', 'gplus:about-me', 'gplus:relationship-status', 'gplus:url', 'gplus:image', 'gplus:organizations', 'gplus:places-lived', 'gplus:language', 'gplus:age-range', 'gplus:circled-by-countv', 'gplus:verified', 'gplus:cover'];

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: {
        allIntents: [],
        intent: {
            Issuer: undefined,
            Code: undefined,
            ShortDescription: undefined,
            Description: undefined,
            Scopes: undefined
        },
        scopes: {
            found: [],
            loading: false
        },
        consents: []
    },
    getters: {},
    /* eslint-disable no-param-reassign */
    mutations: {
        LIST: function LIST(state, data) {
            state.allIntents = data;
        },
        LIST_CONSENTS: function LIST_CONSENTS(state, data) {
            if (data) {
                state.consents = data;
            } else {
                state.consents = [];
            }
        },
        SET: function SET(state, value) {
            if (!value) {
                var organization = this.getters['auth/organisationId'];
                value = {
                    Issuer: organization,
                    Code: undefined,
                    ShortDescription: undefined,
                    Description: undefined,
                    Scopes: []
                };
            }

            state.intent = value;
        },
        UPDATE_CODE: function UPDATE_CODE(state, value) {
            state.intent.Code = value;
        },
        UPDATE_SHORT_DESCRIPTION: function UPDATE_SHORT_DESCRIPTION(state, value) {
            state.intent.ShortDescription = value;
        },
        UPDATE_DESCRIPTION: function UPDATE_DESCRIPTION(state, value) {
            state.intent.Description = value;
        },
        UPDATE_SCOPES: function UPDATE_SCOPES(state, value) {
            state.intent.Scopes = value;
        },
        FOUND_SCOPES: function FOUND_SCOPES(state, value) {
            state.scopes.found = value;
        },
        LOADING_SCOPES: function LOADING_SCOPES(state, value) {
            state.scopes.loading = value;
        }
    },
    /* eslint-disable no-unused-vars */
    actions: {
        LIST_ALL: function LIST_ALL(context) {
            return __WEBPACK_IMPORTED_MODULE_2__utils_api__["a" /* default */].get('/intents').then(function (response) {
                return context.commit('LIST', response.data);
            }).catch(function (error) {
                context.commit('LIST', undefined);
                context.commit('errors/ADD', error, { root: true });
            });
        },
        NEW: function NEW(context) {
            var organization = this.getters['auth/organisationId'];
            context.commit('SET', {
                Issuer: organization,
                Code: undefined,
                ShortDescription: undefined,
                Description: undefined,
                Scopes: []
            });
        },
        QUERY_SCOPES: function QUERY_SCOPES(context, value) {
            context.commit('LOADING_SCOPES', true);
            // TODO turn search for scopes into an api call
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
                return resolve(KNOWN_SCOPES.filter(function (scope) {
                    return (scope || '').toLowerCase().indexOf((value || '').toLowerCase()) > -1;
                }));
            }).then(function (result) {
                context.commit('FOUND_SCOPES', result);
                context.commit('LOADING_SCOPES', false);
            }).catch(function (error) {
                context.commit('errors/ADD', error, { root: true });
                context.commit('LOADING_SCOPES', false);
            });
        },
        SAVE: function SAVE(context) {
            var intentToSave = context.state.intent;
            return __WEBPACK_IMPORTED_MODULE_2__utils_api__["a" /* default */].post('/intents', intentToSave).then(function (response) {
                context.commit('SET', response.data);
                __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({ path: '/intents' });
            }).catch(function (error) {
                context.commit('SET', undefined);
                context.commit('errors/ADD', error, { root: true });
            });
        },
        LIST_INTENT_CONSENTS: function LIST_INTENT_CONSENTS(context, _ref) {
            var issuer = _ref.issuer,
                intent = _ref.intent,
                filter = _ref.filter;

            return __WEBPACK_IMPORTED_MODULE_2__utils_api__["a" /* default */].get('/' + issuer + '/intents/' + intent + '/consents?filter=' + filter).then(function (response) {
                return context.commit('LIST_CONSENTS', response.data);
            }).catch(function (error) {
                context.commit('LIST_CONSENTS', undefined);
                context.commit('errors/ADD', error, { root: true });
            });
        }
    }
});

/***/ }),

/***/ 250:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: {
        title: 'NowYu.WE',
        sidebar: true,
        currentColor: 'amber',
        breadcrumbItems: []
    },
    getters: {},
    /* eslint-disable no-param-reassign */
    mutations: {
        TITLE: function TITLE(state, data) {
            state.title = data;
        },
        SIDEBAR: function SIDEBAR(state, data) {
            state.sidebar = data;
        },
        BREADCRUMBS: function BREADCRUMBS(state, data) {
            state.breadcrumbItems = data;
        }
    },
    actions: {}
});

/***/ }),

/***/ 251:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_api__ = __webpack_require__(13);



/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: {
        providers: [],
        schemas: [],
        endpoints: [],
        mappings: [],
        provider: {},
        params: {
            profileProvider: undefined,
            schema: undefined,
            endpoint: undefined,
            mappings: undefined
        }
    },
    getters: {},
    /* eslint-disable no-param-reassign */
    mutations: {
        LIST: function LIST(state, data) {
            state.providers = data;
            state.schemas = [];
            state.endpoints = [];
            state.mappings = [];
            state.provider = {};
        },
        SET_PARAMS: function SET_PARAMS(state, data) {
            state.params = data || {
                profileProvider: undefined,
                schema: undefined,
                endpoint: undefined,
                mapping: undefined
            };
        },
        SET_PROVIDER: function SET_PROVIDER(state, data) {
            state.provider = data || [];
        },
        SET_SCHEMAS: function SET_SCHEMAS(state, schemas) {
            state.schemas = schemas || [];
        },
        SET_ENDPOINTS: function SET_ENDPOINTS(state, endpoints) {
            state.endpoints = endpoints || [];
        },
        SET_MAPPINGS: function SET_MAPPINGS(state, mappings) {
            state.mappings = mappings || [];
        }
    },
    /* eslint-disable no-unused-vars */
    actions: {
        LIST_ALL: function LIST_ALL(context) {
            return __WEBPACK_IMPORTED_MODULE_1__utils_api__["a" /* default */].get('/profileProviders').then(function (response) {
                return context.commit('LIST', response.data);
            }).catch(function (error) {
                return context.commit('errors/ADD', error, { root: true });
            });
        },
        LOAD: function LOAD(context, value) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_1__utils_api__["a" /* default */].get('/profileProviders/' + value.profileProvider).then(function (providerData) {
                return context.commit('SET_PROVIDER', providerData.data);
            }), __WEBPACK_IMPORTED_MODULE_1__utils_api__["a" /* default */].get('/profileProviders/' + value.profileProvider + '/schemas').then(function (schemasList) {
                return context.commit('SET_SCHEMAS', schemasList.data);
            }), (value.schema ? __WEBPACK_IMPORTED_MODULE_1__utils_api__["a" /* default */].get('/profileProviders/' + value.profileProvider + '/schemas/' + value.schema + '/endpoints') : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve([])).then(function (endpointsList) {
                return context.commit('SET_ENDPOINTS', endpointsList.data);
            }), (value.endpoint ? __WEBPACK_IMPORTED_MODULE_1__utils_api__["a" /* default */].get('/profileProviders/' + value.profileProvider + '/schemas/' + value.schema + '/endpoints/' + value.endpoint + '/mappings') : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve([])).then(function (mappingsList) {
                return context.commit('SET_MAPPINGS', mappingsList.data);
            })]).then(function () {
                return context.commit('SET_PARAMS', value);
            }).catch(function (error) {
                return context.commit('errors/ADD', error, { root: true });
            });
        }
    }
});

/***/ }),

/***/ 252:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_api__ = __webpack_require__(13);


/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: {
        properties: [],
        parent: undefined
    },
    getters: {},
    /* eslint-disable no-param-reassign */
    mutations: {
        LIST: function LIST(state, data) {
            state.properties = data || [];
        },
        PARENT_PROP: function PARENT_PROP(state, data) {
            state.parent = data || undefined;
        }
    },
    actions: {
        LIST_ALL: function LIST_ALL(context, parent) {
            context.commit('PARENT_PROP', parent);

            var url = '/properties';
            if (context.state.parent) {
                url += '/' + context.state.parent + '/properties';
            }

            return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].get(url).then(function (response) {
                return context.commit('LIST', response.data);
            }, function (response) {
                return context.commit('errors/ADD', response, { root: true });
            });
        }
    }
});

/***/ }),

/***/ 253:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_MainLayout__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_MainLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__layouts_MainLayout__);
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app',
    components: {
        MainLayout: __WEBPACK_IMPORTED_MODULE_0__layouts_MainLayout___default.a
    },
    data: function data() {
        return {
            // screen title
            title: 'NowYu.WE'
        };
    },

    watch: {
        /* eslint-disable object-shorthand */
        '$route': function $route(to, from) {
            this.setMeta(to, from);
        }
    },
    methods: {
        setMeta: function setMeta(to) {
            if (typeof document === 'undefined') return;

            document.title = to.meta.window_title;
            this.$store.commit('nav/TITLE', to.meta.title);
        }
    }
});

/***/ }),

/***/ 254:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'FilteredConsentsList',
    props: {
        consents: { type: Array, required: true }
    },
    data: function data() {
        return {
            tabs: ['all', 'granted', 'revoked'],
            active_tab: 'all'
        };
    },

    computed: {
        filter: {
            get: function get() {
                return this.active_tab;
            },
            set: function set(filter) {
                this.$emit('filter', filter);
            }
        }
    },
    methods: {
        key: function key(consent) {
            return consent.IntentIssuerCode + '_' + consent.IntentCode + '_' + consent.DataOwnerCode;
        },
        userReadable: function userReadable(date) {
            return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('LLL');
        },
        details: function details(item) {
            this.$router.push({ path: '/consents/' + item.IntentIssuerCode + '/' + item.IntentCode + '/' + item.DataOwnerCode });
        }
    },
    created: function created() {}
});

/***/ }),

/***/ 255:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(18);

//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'main-breadcrumb',
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('nav', {
        items: function items(state) {
            return state.breadcrumbItems;
        }
    })),
    methods: {}
});

/***/ }),

/***/ 256:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_auth__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_api__ = __webpack_require__(13);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'main-navigation',
    data: function data() {
        return {
            // drawer items
            items: [{ icon: 'bubble_chart', text: 'Intents', route: '/intents' }, { icon: 'swap_calls', text: 'Consents', route: '/consents' }, { divider: true }, { heading: 'Meta', editable: false }, { icon: 'data_usage', text: 'Properties', route: '/properties' }, { icon: 'data_usage', text: 'Providers', route: '/providers' }, { icon: 'file_download', text: 'Mappings', download: '/profileProvidersSchemaEnpointMappings?format=csv', file: 'Mappings.csv' }, { divider: true }, { heading: 'Support', editable: false }, { icon: 'domain', text: 'Organisation', route: '/organisation' }, { icon: 'mdi-account', text: 'Users', route: '/organisation/users' }, { icon: 'settings', text: 'Settings', route: '/settings' }]
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('auth', ['profile']), {
        isActive: {
            get: function get() {
                return this.$store.state.nav.sidebar;
            },
            set: function set(value) {
                this.$store.commit('nav/SIDEBAR', value);
            }
        },
        showProfile: function showProfile() {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__store_auth__["a" /* isAuthenticated */])();
        }
    }),
    methods: {
        nav: function nav(item) {
            if (item.route) {
                this.goto(item.route);
            } else if (item.download) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_api__["b" /* download */])(item.download, item.file);
            }
        },
        goto: function goto(route) {
            this.$router.push({ path: route });
        },
        signOut: function signOut() {
            this.$store.commit('auth/LOGOUT');
            this.$router.push({ path: '/login' });
        }
    }
});

/***/ }),

/***/ 257:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_auth__ = __webpack_require__(21);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'main-toolbar',
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('auth', ['profile']), {
        isTopLevel: function isTopLevel() {
            return this.$store.state.route.fullPath.indexOf('/', 1) === -1;
        }
    }),
    methods: {
        showProfile: function showProfile() {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__store_auth__["a" /* isAuthenticated */])();
        },
        toggleSidebar: function toggleSidebar() {
            this.$store.commit('nav/SIDEBAR', !this.$store.state.nav.sidebar);
        },
        back: function back() {
            this.$router.go(-1);
        },
        signOut: function signOut() {
            this.$store.commit('auth/LOGOUT');
            this.$router.push({ path: '/login' });
        }
    }
});

/***/ }),

/***/ 258:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//    import { mapGetters } from 'vuex';
//    import { NAV_SIDEBAR, AUTH_LOGOUT } from '../store/mutations';

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'profile-provider-card',
    props: ['provider'],
    data: function data() {
        return {};
    },

    methods: {
        //            toggleSidebar() {
        //                this.$store.commit(NAV_SIDEBAR, !this.$store.state.nav.sidebar);
        //            },
        //            signOut() {
        //                this.$store.commit(AUTH_LOGOUT);
        //                this.$router.push({ path: '/login' });
        //            },
    }
});

/***/ }),

/***/ 259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_MainNavigation__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_MainNavigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_MainNavigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_MainToolbar__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_MainToolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_MainToolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MainFooter__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MainFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_MainFooter__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        MainNavigation: __WEBPACK_IMPORTED_MODULE_0__components_MainNavigation___default.a,
        MainToolbar: __WEBPACK_IMPORTED_MODULE_1__components_MainToolbar___default.a,
        MainFooter: __WEBPACK_IMPORTED_MODULE_2__components_MainFooter___default.a
    },
    methods: {}
});

/***/ }),

/***/ 307:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 308:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 309:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 31:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_auth__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__meta_json__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__meta_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__meta_json__);






/* eslint no-use-before-define: ["error", { "functions": false }] */
function fromRouteMap(routes) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(routes).map(function (element) {
        return fromRoute(element[0], element[1]);
    });
}

function fromRoute(path, meta) {
    var view = meta.title ? meta.title : 'NotFound';
    var page = meta.page ? meta.page : view;
    var redirect = meta.redirect;
    var result = {
        path: path,
        meta: meta
    };

    if (page) {
        result.component = function () {
            return __webpack_require__(346)("./" + page + '.vue');
        };
    }

    if (redirect) {
        result.redirect = redirect;
    }

    if (meta.children) {
        result.children = fromRouteMap(meta.children);
    }

    if (meta.props) {
        result.props = meta.props;
    }

    return result;
}

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);
var routes = fromRouteMap(__WEBPACK_IMPORTED_MODULE_4__meta_json___default.a);
var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
    saveScrollPosition: true,
    mode: 'history',
    routes: routes
});

router.beforeEach(function (to, from, next) {
    if (to.path !== '/login' && to.path !== '/login/callback' && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__store_auth__["a" /* isAuthenticated */])()) {
        next({
            path: '/login',
            query: {
                redirect: to.fullPath
            }
        });
    } else {
        next();
    }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 310:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 311:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 322:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 71,
	"./af.js": 71,
	"./ar": 78,
	"./ar-dz": 72,
	"./ar-dz.js": 72,
	"./ar-kw": 73,
	"./ar-kw.js": 73,
	"./ar-ly": 74,
	"./ar-ly.js": 74,
	"./ar-ma": 75,
	"./ar-ma.js": 75,
	"./ar-sa": 76,
	"./ar-sa.js": 76,
	"./ar-tn": 77,
	"./ar-tn.js": 77,
	"./ar.js": 78,
	"./az": 79,
	"./az.js": 79,
	"./be": 80,
	"./be.js": 80,
	"./bg": 81,
	"./bg.js": 81,
	"./bm": 82,
	"./bm.js": 82,
	"./bn": 83,
	"./bn.js": 83,
	"./bo": 84,
	"./bo.js": 84,
	"./br": 85,
	"./br.js": 85,
	"./bs": 86,
	"./bs.js": 86,
	"./ca": 87,
	"./ca.js": 87,
	"./cs": 88,
	"./cs.js": 88,
	"./cv": 89,
	"./cv.js": 89,
	"./cy": 90,
	"./cy.js": 90,
	"./da": 91,
	"./da.js": 91,
	"./de": 94,
	"./de-at": 92,
	"./de-at.js": 92,
	"./de-ch": 93,
	"./de-ch.js": 93,
	"./de.js": 94,
	"./dv": 95,
	"./dv.js": 95,
	"./el": 96,
	"./el.js": 96,
	"./en-au": 97,
	"./en-au.js": 97,
	"./en-ca": 98,
	"./en-ca.js": 98,
	"./en-gb": 99,
	"./en-gb.js": 99,
	"./en-ie": 100,
	"./en-ie.js": 100,
	"./en-nz": 101,
	"./en-nz.js": 101,
	"./eo": 102,
	"./eo.js": 102,
	"./es": 105,
	"./es-do": 103,
	"./es-do.js": 103,
	"./es-us": 104,
	"./es-us.js": 104,
	"./es.js": 105,
	"./et": 106,
	"./et.js": 106,
	"./eu": 107,
	"./eu.js": 107,
	"./fa": 108,
	"./fa.js": 108,
	"./fi": 109,
	"./fi.js": 109,
	"./fo": 110,
	"./fo.js": 110,
	"./fr": 113,
	"./fr-ca": 111,
	"./fr-ca.js": 111,
	"./fr-ch": 112,
	"./fr-ch.js": 112,
	"./fr.js": 113,
	"./fy": 114,
	"./fy.js": 114,
	"./gd": 115,
	"./gd.js": 115,
	"./gl": 116,
	"./gl.js": 116,
	"./gom-latn": 117,
	"./gom-latn.js": 117,
	"./gu": 118,
	"./gu.js": 118,
	"./he": 119,
	"./he.js": 119,
	"./hi": 120,
	"./hi.js": 120,
	"./hr": 121,
	"./hr.js": 121,
	"./hu": 122,
	"./hu.js": 122,
	"./hy-am": 123,
	"./hy-am.js": 123,
	"./id": 124,
	"./id.js": 124,
	"./is": 125,
	"./is.js": 125,
	"./it": 126,
	"./it.js": 126,
	"./ja": 127,
	"./ja.js": 127,
	"./jv": 128,
	"./jv.js": 128,
	"./ka": 129,
	"./ka.js": 129,
	"./kk": 130,
	"./kk.js": 130,
	"./km": 131,
	"./km.js": 131,
	"./kn": 132,
	"./kn.js": 132,
	"./ko": 133,
	"./ko.js": 133,
	"./ky": 134,
	"./ky.js": 134,
	"./lb": 135,
	"./lb.js": 135,
	"./lo": 136,
	"./lo.js": 136,
	"./lt": 137,
	"./lt.js": 137,
	"./lv": 138,
	"./lv.js": 138,
	"./me": 139,
	"./me.js": 139,
	"./mi": 140,
	"./mi.js": 140,
	"./mk": 141,
	"./mk.js": 141,
	"./ml": 142,
	"./ml.js": 142,
	"./mr": 143,
	"./mr.js": 143,
	"./ms": 145,
	"./ms-my": 144,
	"./ms-my.js": 144,
	"./ms.js": 145,
	"./my": 146,
	"./my.js": 146,
	"./nb": 147,
	"./nb.js": 147,
	"./ne": 148,
	"./ne.js": 148,
	"./nl": 150,
	"./nl-be": 149,
	"./nl-be.js": 149,
	"./nl.js": 150,
	"./nn": 151,
	"./nn.js": 151,
	"./pa-in": 152,
	"./pa-in.js": 152,
	"./pl": 153,
	"./pl.js": 153,
	"./pt": 155,
	"./pt-br": 154,
	"./pt-br.js": 154,
	"./pt.js": 155,
	"./ro": 156,
	"./ro.js": 156,
	"./ru": 157,
	"./ru.js": 157,
	"./sd": 158,
	"./sd.js": 158,
	"./se": 159,
	"./se.js": 159,
	"./si": 160,
	"./si.js": 160,
	"./sk": 161,
	"./sk.js": 161,
	"./sl": 162,
	"./sl.js": 162,
	"./sq": 163,
	"./sq.js": 163,
	"./sr": 165,
	"./sr-cyrl": 164,
	"./sr-cyrl.js": 164,
	"./sr.js": 165,
	"./ss": 166,
	"./ss.js": 166,
	"./sv": 167,
	"./sv.js": 167,
	"./sw": 168,
	"./sw.js": 168,
	"./ta": 169,
	"./ta.js": 169,
	"./te": 170,
	"./te.js": 170,
	"./tet": 171,
	"./tet.js": 171,
	"./th": 172,
	"./th.js": 172,
	"./tl-ph": 173,
	"./tl-ph.js": 173,
	"./tlh": 174,
	"./tlh.js": 174,
	"./tr": 175,
	"./tr.js": 175,
	"./tzl": 176,
	"./tzl.js": 176,
	"./tzm": 178,
	"./tzm-latn": 177,
	"./tzm-latn.js": 177,
	"./tzm.js": 178,
	"./uk": 179,
	"./uk.js": 179,
	"./ur": 180,
	"./ur.js": 180,
	"./uz": 182,
	"./uz-latn": 181,
	"./uz-latn.js": 181,
	"./uz.js": 182,
	"./vi": 183,
	"./vi.js": 183,
	"./x-pseudo": 184,
	"./x-pseudo.js": 184,
	"./yo": 185,
	"./yo.js": 185,
	"./zh-cn": 186,
	"./zh-cn.js": 186,
	"./zh-hk": 187,
	"./zh-hk.js": 187,
	"./zh-tw": 188,
	"./zh-tw.js": 188
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 322;

/***/ }),

/***/ 331:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(307)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(254),
  /* template */
  __webpack_require__(334),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1c512364",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 332:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(309)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(255),
  /* template */
  __webpack_require__(337),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 333:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(308)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(259),
  /* template */
  __webpack_require__(335),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 334:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticStyle: {
      "min-height": "0"
    },
    attrs: {
      "fluid": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "fixed": "",
      "centered": ""
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }, [_c('v-tabs-bar', {
    staticClass: "grey lighten-5"
  }, [_c('v-tabs-slider', {
    staticClass: "amber"
  }), _vm._v(" "), _vm._l((_vm.tabs), function(tab) {
    return _c('v-tabs-item', {
      key: tab,
      attrs: {
        "ripple": "",
        "href": '#' + tab
      }
    }, [_vm._v("\n                " + _vm._s(tab) + "\n            ")])
  })], 2)], 1), _vm._v(" "), (_vm.consents.length === 0) ? _c('div', {
    staticClass: "text-xs-center pt-2 pb-2 grey--text text--darken-1"
  }, [_vm._v("No results")]) : [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.consents && _vm.consents.length > 0) ? _c('v-card', [_c('v-list', {
    attrs: {
      "three-line": ""
    }
  }, _vm._l((_vm.consents), function(item, index) {
    return _c('v-list-tile', {
      key: _vm.key(item),
      attrs: {
        "avatar": "",
        "ripple": ""
      },
      on: {
        "click": function($event) {
          _vm.details(item, index)
        }
      }
    }, [_c('v-list-tile-avatar', [_c('v-icon', {
      class: item.Status
    }, [_vm._v("fa-code-fork")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      staticClass: "bold"
    }, [_vm._v(_vm._s(item.DataOwnerCode))]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(item.Intent.ShortDescription))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.userReadable(item.Expiration)))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', {
      staticClass: "visible-hover"
    }, [_vm._v("mode_edit")])], 1)], 1)
  }))], 1) : _vm._e()], 1)], 1)]], 2)
},staticRenderFns: []}

/***/ }),

/***/ 335:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "id": "nowyu",
      "toolbar": "",
      "footer": ""
    }
  }, [_c('main-navigation'), _vm._v(" "), _c('main-toolbar'), _vm._v(" "), _c('main', [_c('v-container', {
    attrs: {
      "fluid": "",
      "pl-5": "",
      "pr-5": ""
    }
  }, [_c('main-breadcrumb'), _vm._v(" "), _c('v-slide-y-transition', {
    attrs: {
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('main-footer')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 336:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    on: {
      "click": function($event) {
        _vm.$emit('select')
      }
    }
  }, [_c('v-card-media', {
    staticClass: "text-xs-center"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100px",
      "max-height": "100px",
      "margin": "20px"
    },
    attrs: {
      "src": _vm.provider.Logo
    }
  })]), _vm._v(" "), _c('v-card-actions', {
    staticClass: "white"
  }, [_c('span', [_vm._v(_vm._s(_vm.provider.Name))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("compare_arrows")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 337:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-breadcrumbs', {
    staticClass: "pl-4",
    attrs: {
      "icons": "",
      "divider": "chevron_right"
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('v-breadcrumbs-item', {
      key: item.id,
      attrs: {
        "to": item.to,
        "exact": true
      }
    }, [_vm._v("\n        " + _vm._s(item.text) + "\n    ")])
  }))
},staticRenderFns: []}

/***/ }),

/***/ 338:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-navigation-drawer', {
    staticClass: "pb-0 grey lighten-5",
    attrs: {
      "id": "main-navigation",
      "persistent": "",
      "clipped": "",
      "floating": "",
      "height": "100%",
      "light": "",
      "enable-resize-watcher": ""
    },
    model: {
      value: (_vm.isActive),
      callback: function($$v) {
        _vm.isActive = $$v
      },
      expression: "isActive"
    }
  }, [_c('v-list', {
    staticClass: "grey lighten-5",
    attrs: {
      "dense": ""
    }
  }, [(_vm.showProfile) ? _c('v-container', {
    attrs: {
      "pa-0": "",
      "ma-0": "",
      "hidden-md-and-up": "",
      "text-xs-center": ""
    }
  }, [_c('v-list', {
    staticClass: "grey lighten-5",
    attrs: {
      "three-line": "",
      "dense": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-avatar', [_c('img', {
    attrs: {
      "src": _vm.profile.picture
    }
  })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    domProps: {
      "innerHTML": _vm._s(_vm.profile.name)
    }
  }), _vm._v(" "), _c('v-list-tile-sub-title', {
    staticClass: "grey--text text--darken-4",
    domProps: {
      "innerHTML": _vm._s(_vm.profile.email)
    }
  }), _vm._v(" "), _c('v-list-tile-sub-title', {
    domProps: {
      "innerHTML": _vm._s(_vm.profile.sub)
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "text-xs-right": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "primary": "",
      "flat": "",
      "text-xs-right": ""
    },
    on: {
      "click": function($event) {
        _vm.signOut()
      }
    }
  }, [_vm._v("Sign out")])], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "my-1",
    attrs: {
      "dark": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.items), function(item, i) {
    return [(item.heading) ? _c('v-layout', {
      key: i,
      attrs: {
        "row": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [(item.heading) ? _c('v-subheader', [_vm._v("\n                        " + _vm._s(item.heading) + "\n                    ")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "text-xs-center",
      attrs: {
        "xs6": ""
      }
    }, [(item.editable) ? _c('v-btn', {
      attrs: {
        "small": "",
        "flat": ""
      }
    }, [_vm._v("edit")]) : _vm._e()], 1)], 1) : (item.divider) ? _c('v-divider', {
      key: i,
      staticClass: "my-1",
      attrs: {
        "dark": ""
      }
    }) : _c('v-list-tile', {
      key: i,
      on: {
        "click": function($event) {
          _vm.nav(item)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                        " + _vm._s(item.text) + "\n                    ")])], 1)], 1)]
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 339:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-toolbar', {
    ref: "main-toolbar",
    staticClass: "amber",
    attrs: {
      "fixed": ""
    }
  }, [(!_vm.isTopLevel) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "light": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.back()
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")])], 1) : _c('v-toolbar-side-icon', {
    attrs: {
      "light": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleSidebar()
      }
    }
  }), _vm._v(" "), _c('v-toolbar-title', {
    staticClass: "d-flex",
    staticStyle: {
      "position": "relative"
    },
    domProps: {
      "textContent": _vm._s(_vm.$store.state.nav.title)
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.showProfile()) ? _c('div', {
    staticClass: "hidden-sm-and-down"
  }, [_c('v-menu', {
    attrs: {
      "offset-y": ""
    }
  }, [_c('v-avatar', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('img', {
    attrs: {
      "alt": _vm.profile.name,
      "src": _vm.profile.picture
    }
  })]), _vm._v(" "), _c('v-card', [_c('v-list', {
    attrs: {
      "three-line": "",
      "dense": ""
    }
  }, [_c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-avatar', [_c('img', {
    attrs: {
      "src": _vm.profile.picture
    }
  })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    domProps: {
      "innerHTML": _vm._s(_vm.profile.name)
    }
  }), _vm._v(" "), _c('v-list-tile-sub-title', {
    staticClass: "grey--text text--darken-4",
    domProps: {
      "innerHTML": _vm._s(_vm.profile.email)
    }
  }), _vm._v(" "), _c('v-list-tile-sub-title', {
    domProps: {
      "innerHTML": _vm._s(_vm.profile.sub)
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "primary": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.signOut()
      }
    }
  }, [_vm._v("Sign out")])], 1)], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 340:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main-layout')
},staticRenderFns: []}

/***/ }),

/***/ 341:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-footer', {
    staticClass: "pa-3"
  }, [_c('v-spacer'), _vm._v(" "), _c('div', [_vm._v("Innacco © " + _vm._s(new Date().getFullYear()))])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 346:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Callback.vue": 351,
	"./Consent.vue": 352,
	"./Consents.vue": 353,
	"./Intent.vue": 354,
	"./Intents.vue": 355,
	"./IntentsNew.vue": 356,
	"./Login.vue": 357,
	"./NotFound.vue": 358,
	"./ProfileProvider.vue": 359,
	"./ProfileProviders.vue": 360,
	"./Properties.vue": 361
};
function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(__webpack_require__);
};
function webpackAsyncContextResolve(req) {
	return __webpack_require__.e/* lazy-once context */(0).then(function() {
		var id = map[req];
		if(!(id + 1)) // check for number or string
			throw new Error("Cannot find module '" + req + "'.");
		return id;
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.resolve = webpackAsyncContextResolve;
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 346;

/***/ }),

/***/ 347:
/***/ (function(module, exports) {

module.exports = {"/providers/:profilePath+":{"name":"provider","title":"Profile Provider","page":"ProfileProvider","window_title":"NowYu.WE - profile provider details","props":true},"/providers":{"name":"providers","title":"Profile Providers","page":"ProfileProviders","window_title":"NowYu.WE - profile provider overview"},"/properties/:propspath*":{"name":"properties","title":"Properties","page":"Properties","window_title":"NowYu.WE - List of properties","props":true},"/intents":{"name":"intents","title":"Intents","window_title":"NowYu.WE - manage your intents"},"/intents/:issuer/:intent":{"name":"intent","title":"Intent","window_title":"NowYu.WE - Intent details","props":true},"/intents/new":{"name":"intentsNew","title":"New Intent","page":"IntentsNew","window_title":"NowYu.WE - Creat a new intent"},"/consents":{"name":"consents","title":"Consents","window_title":"NowYu.WE - manage your users consents"},"/consents/:issuer/:intent/:user":{"name":"consent","title":"Consent","window_title":"NowYu.WE - consent details","props":true},"/login":{"name":"login","title":"Login","window_title":"NowYu.WE - login to NowYou platform"},"/login/callback":{"name":"callback","title":"Login callback","window_title":"NowYu.WE - login callback to NowYou platform","page":"Callback"},"/":{"name":"home","redirect":"/intents"},"*":{"name":"not-found","title":"Not Found","window_title":"NowYu.WE - Not found","page":"NotFound"}}

/***/ }),

/***/ 348:
/***/ (function(module, exports) {

module.exports = {"domain":"nowyu.eu.auth0.com","clientId":"bwYfaa6k4S6yGZMpLI0ffl0VlED0I44w","callbackUrl":"https://we.nowyu.com/login/callback","audience":"api.nowyu.com","responseType":"token id_token","scope":"openid email profile"}

/***/ })

},[246]);


// WEBPACK FOOTER //
// static/js/app.6c05d88c6ba4535dcec0.js